import { ApiResponse, ValidateResponse, InstancesData } from '../types/api';

class ApiClient {
  private baseUrl = '/api';

  private async fetchApi<T>(
    endpoint: string, 
    options: RequestInit = {}
  ): Promise<ApiResponse<T>> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      const data = await response.json();

      return {
        data: response.ok ? data : undefined,
        error: response.ok ? undefined : data.error || 'Error desconocido',
        status: response.status,
      };
    } catch (error) {
      return {
        error: 'Error de conexión',
        status: 0,
      };
    }
  }

  async validateToken(token: string): Promise<ApiResponse<ValidateResponse>> {
    return this.fetchApi<ValidateResponse>('/validate', {
      method: 'POST',
      body: JSON.stringify({ token }),
    });
  }

  async getData(token: string, raApi: string): Promise<ApiResponse<InstancesData>> {
    return this.fetchApi('/data', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-RA-API': raApi,
      },
    });
  }

  async getData2(token: string, raApi: string): Promise<ApiResponse<InstancesData>> {
    return this.fetchApi('/data2', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-RA-API': raApi,
      },
    });
  }
}

export const apiClient = new ApiClient();
